import styled from 'styled-components';
import { Card, Dimmer } from 'semantic-ui-react';

import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled(Dimmer)``;

export const Dialog = styled(Card)`
  &.ui.card {
    display: flex;
    padding: 30px;
    width: 400px;
    background-color: ${({ theme }) => theme.background};
    height: 180px;
    border-radius: 1px;
    justify-content: space-between;
    align-items: center;

    :after {
      display: none;
    }
  }
`;

export const Content = styled.div``;

export const Text = styled(TextLayoutComponent)`
  text-align: justify;
  ${({ margin }) => margin && `
    margin-bottom: 10px;
  `}
`;

export const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    width: 80px;
  }
`;
